import React from 'react';

import AdornmentTextField from '../AdornmentTextField';
import {CheckIcon, InvalidIcon} from '../Icon';
import Deadline from '../Deadline';
import Loading from '../Loading';
import Button from '../Button';

import {useTranslation} from 'react-i18next';

import {IPromotion} from '../../state-management/app';

import {daysDifferentFromTimeToTime} from '../../utils';
import {PROMOTION_STATUS} from '../../constants/enum';
import {DAYS_IN_WEEK} from '../../constants/value';

import styles from './Promotion.module.css';

interface PromotionProps {
  promotion: IPromotion

  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onConfirm: (rawPromotion: string) => void
  onClick: () => void
}

export function renderIcon(promotion: IPromotion) {
  switch (promotion.status) {
    case PROMOTION_STATUS.INVALID:
      return <InvalidIcon width={24} height={24}/>;
    case PROMOTION_STATUS.VALID:
      return <CheckIcon width={24} height={24}/>;
    case PROMOTION_STATUS.LOADING:
      return <Loading size="24px"/>;
    case PROMOTION_STATUS.UNDETERMINED:
      return null;
    default:
      return null
  }
}


const Promotion = ({promotion, onChange, onConfirm, onClick}: PromotionProps) => {
  const {t} = useTranslation();

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onConfirm(promotion.text);
    }
  };

  const willShowPromoErr = promotion.status === PROMOTION_STATUS.INVALID && promotion.err; //not empty, status invalid & have err

  return (
    <>
      <div className={styles.root}>
        <div className={styles.inputWrapper}>
          <AdornmentTextField
            className={styles.inputFullWidth}
            inputClassName={styles.input}
            type="email"
            placeholder={t('enterCode')}
            value={promotion.text}
            onChange={onChange}
            onKeyDown={onKeyDown}
            onFocus={onClick}
          >
            {renderIcon(promotion)}
          </AdornmentTextField>
        </div>
        <Button
          className={styles.button}
          disabled={!promotion.text || promotion.status === PROMOTION_STATUS.LOADING}
          onClick={() => onConfirm(promotion.text)}
        >
          {t('apply')}
        </Button>
      </div>
      {
        willShowPromoErr &&
        <div className={styles.error}>{t(promotion.err)}</div>
      }
      {
        promotion.status === PROMOTION_STATUS.VALID &&
        promotion.expiryDate &&
        daysDifferentFromTimeToTime(promotion.expiryDate!, Date.now() / 1000) < DAYS_IN_WEEK && //when expiry day < a week, show the deadline
        <Deadline
          className={styles.deadline}
          textClassName={styles.deadlineText}
          deadline={promotion.expiryDate!}
          separateDateTimeString={t('at')}
          startString={t('expiringOn')}
        />
      }
    </>
  );
};

export default Promotion;
